@if (isLoading) {
  <app-main-loader-lottie> </app-main-loader-lottie>
} @else {
  <form class="settings-fields-container" [formGroup]="formGroup" (submit)="onSubmit()">
    <div class="fields-area" [ngClass]="fieldsAreaClasses">
      <div class="settings-header-row">
        <span class="title">Account Settings</span>
        <pdq-button
          class="sync-btn"
          [ngClass]="{ disabled: isEnabledSync }"
          [icon]="'sync'"
          label="Sync shop details"
          variant="light"
          (click)="syncShopDetails()"
          >sync</pdq-button
        >
        @if (isShopifyShop) {
          <div class="sync-products-btn-container">
            @if (isProductsSyncing()) {
              <pdq-button
                [plain]="true"
                size="large"
                iconColor="var(--error-default)"
                icon="not_allowed"
                (onClick)="cancelProductsSync()">
              </pdq-button>
            }
            <pdq-button
              variant="light"
              icon="sync"
              [label]="
                isProductsSyncing() ? 'Syncing products (' + (productsSyncedCount() | number) + ')' : 'Sync products'
              "
              [loading]="isProductsSyncing()"
              (onClick)="openSyncProductsDialog()">
            </pdq-button>
          </div>
        } @else {
          <pdq-button
            class="sync-btn"
            icon="sync"
            label="Sync products"
            variant="light"
            [disabled]="!isAllowedSyncProducts"
            (click)="syncProducts()"
            [matTooltipDisabled]="isAllowedSyncProducts"
            [matTooltip]="'sync complete in ' + syncRemainingTime + ' minutes'"
            matTooltipClass="pdq-mat-tooltip"
            >sync</pdq-button
          >
        }
        @if (isAdmin && shop.metadata.resetShopEnable) {
          <pdq-button
            [ngClass]="{ disabled: !resetStoreCompleted }"
            class="sync-btn"
            icon="sync"
            label="Reset Shop"
            variant="light"
            [disabled]="!resetStoreCompleted"
            (click)="resetDemoShop()"
            [matTooltipDisabled]="isAllowedSyncProducts"
            [matTooltip]="'reset store (works only with demo-store)'"
            matTooltipClass="pdq-mat-tooltip">
          </pdq-button>
        }
      </div>
      @for (field of fieldsSettings; track field; let idx = $index) {
        <div class="settings-row">
          @if (field.type === FieldType.INPUT) {
            <pdq-input
              formControlName="{{ field.name }}"
              name="{{ field.name }}"
              [label]="field.label"
              [placeholder]="field.placeholder"
              variant="form"
              [disabled]="!field.editable"
              [clipboard]="field.clipboard"
              [invalid]="!isControlValid(field.name)"
              [invalidMsg]="field.validationMsg"
              [tooltip]="field.tooltip"
              autocomplete="off"></pdq-input>
          }
          @if (field.type === FieldType.FILE) {
            <form #fileForm formGroupName="{{ field.name }}" submit="onSubmitLogo()">
              <pdq-input-file
                [formControl]="formGroup.get(field.name).controls.logo"
                name="{{ field.name }}"
                [file]="logoFile"
                [initialImage]="defaultLogoSrc"
                [label]="field.label"
                removeButtonLabel="Remove logo"
                [disabled]="!field.editable"
                [tooltip]="field.tooltip"
                [supportedFormat]="['image/png']"
                [maxKBSize]="100"
                (onClearFile)="clearLogo()"></pdq-input-file>
              <input [hidden]="true" #submitLogoForm type="submit" value="submit logo" />
            </form>
          }
          @if (
            field.type === FieldType.TOGGLE ||
            field.type === FieldType.INPUT_ARROW ||
            field.type === FieldType.TIME_INPUT
          ) {
            <pdq-settings-line [name]="field.name" [title]="field.label" [description]="field.description">
              @if (field.type === FieldType.TOGGLE) {
                <pdq-slide-toggle
                  [formControl]="
                    field.nestedFormControl
                      ? formGroup.controls[field.name].controls[field.nestedFormControl]
                      : formGroup.controls[field.name]
                  ">
                </pdq-slide-toggle>
              }
              @if (field.type === FieldType.INPUT_ARROW) {
                <pdq-input-arrows
                  precision="0"
                  [formControl]="formGroup.controls[field.name]"
                  [min]="field.min"
                  [max]="field.max"
                  [placeholder]="formGroup.controls[field.name]">
                </pdq-input-arrows>
              }
              @if (field.type === FieldType.TIME_INPUT) {
                <div
                  formGroupName="pickupCutoffTime"
                  style="display: flex; flex-direction: row; gap: 5px; align-items: center">
                  <pdq-input
                    formControlName="hours"
                    variant="form"
                    width="51"
                    type="number"
                    placeholder="HH"
                    [invalid]="
                      !formGroup.controls['pickupCutoffTime'].valid && formGroup.controls['pickupCutoffTime'].dirty
                    "
                    [maxLength]="2"
                    [border]="true">
                  </pdq-input>
                  :
                  <pdq-input
                    formControlName="minutes"
                    variant="form"
                    type="number"
                    placeholder="MM"
                    width="51"
                    [invalid]="
                      !formGroup.controls['pickupCutoffTime'].controls['minutes'].valid &&
                      formGroup.controls['pickupCutoffTime'].controls['minutes'].dirty
                    "
                    [maxLength]="2"
                    [border]="true">
                  </pdq-input>
                  <pdq-dropdown
                    mode="default"
                    formControlName="units"
                    [options]="timeUnits"
                    [defaultOption]="timeUnits[0]">
                  </pdq-dropdown>
                  @if (
                    formGroup.get('pickupCutoffTime.minutes').value || formGroup.get('pickupCutoffTime.hours').value
                  ) {
                    <pdq-button (onClick)="clearCutoff()" size="large" icon="close"></pdq-button>
                  }
                </div>
              }
            </pdq-settings-line>
          }
          @if (field.templateRef && formGroup.value[field.name]?.active) {
            <ng-container
              [ngTemplateOutlet]="this[field.templateRef]"
              [ngTemplateOutletContext]="{
                subFormGroupControls: formGroup.controls[field.name],
                subFormFields: field.subFormFields,
              }"></ng-container>
          }
        </div>
      }
    </div>
    <footer [ngClass]="footerStateClasses">
      <span>{{ changedStatusTxt }}</span>
      <pdq-button variant="secondary" (click)="resetForm()" label="cancel" class="action-btn">cancel</pdq-button>
      <pdq-button
        variant="primary"
        type="submit"
        label="save"
        class="action-btn"
        [disabled]="!isValid"
        (click)="onSubmit()"
        >save</pdq-button
      >
    </footer>
    <div class="notification-area">
      <pdq-snackbar
        [variant]="notification.type"
        [notificationText]="notification.msg"
        [notificationDuration]="notification.duration"
        [notificationState]="notification.state">
      </pdq-snackbar>
    </div>
  </form>
}

<ng-template #additionalSubFormFields let-subFormGroupControls="subFormGroupControls" let-subFormFields="subFormFields">
  @for (subField of subFormFields; track subField) {
    @if (subField.type == FieldType.RADIO) {
      <pdq-radio-group [formControl]="subFormGroupControls.controls[subField.dataName]">
        @for (option of subField.options; track option) {
          <pdq-radio-button [text]="option.label" [value]="option.value"></pdq-radio-button>
        }
      </pdq-radio-group>
    }
    @if (subField.type == FieldType.INPUT) {
      <pdq-input
        [label]="subField.label"
        [placeholder]="subField.placeholder"
        [formControl]="subFormGroupControls.controls[subField.dataName]"
        width="250"
        [invalid]="
          !subFormGroupControls.controls[subField.dataName].valid &&
          subFormGroupControls.controls[subField.dataName].dirty
        "></pdq-input>
    }
    @if (subField.type == FieldType.CHECKBOX) {
      <pdq-checkbox
        [label]="subField.label"
        [formControl]="subFormGroupControls.controls[subField.dataName]"></pdq-checkbox>
    }
  }
</ng-template>
